export default __webpack_public_path__ + "static/media/dailyview.6204b190.png";